var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

        var initializeBlock = function ($block) {

            const tabButton = $('.block-locations__tabs-nav .fz-button-rounded--tab');
            const tab = $('.block-locations .row--tab');
            tabButton.on('click', function(e){
                e.preventDefault();
                tabButton.removeClass('is-active');
                $(this).addClass('is-active');

                tab.removeClass('is-active');
                tab.eq($(this).index()).addClass('is-active');
            });

            const swipers = tab;
            const swipersArray = [];
            let counter = 0;
            swipers.each(function(){
                const index = $(this).index();

                const swiper = $('.card-swiper-container',$(this));
                swiper.addClass('card-swiper-container--' + counter);

                const prev = $('.swiper-button-prev', $(this));
                prev.addClass('swiper-button-prev--' + counter);
                const next = $('.swiper-button-next', $(this));
                next.addClass('swiper-button-next--' + counter);

                const pagination = $('.swiper-pagination', $(this));
                pagination.addClass('swiper-pagination--' + counter);

                swipersArray[counter] = new Swiper('.card-swiper-container--' + counter, {
                    slidesPerView: "auto",
                    //centeredSlides: true,
                    loop: true,
                    speed: 400,
                    spaceBetween: 0,
                    initialSlide: 0,
                    navigation: {
                        nextEl: '.swiper-button-next--' + counter,
                        prevEl: '.swiper-button-prev--' + counter,
                    },
                    pagination: {
                        el: '.swiper-pagination--' + counter,
                        clickable: true
                    },
                });

                swipersArray[counter]
                    .on('click', prev, function() {
                        swipersArray[counter].slidePrev();
                    })
                    .on('click', next, function() {
                        swipersArray[counter].slideNext();
                    });

                counter++;
            });

            function delay() {
                tabButton.eq(0).click();
            }
            setTimeout(delay,100);



            // Maps
            // API: AIzaSyCkKf-D4Gh5HyxREb5e2jx5eH1nRX25aIM
            // API2: AIzaSyAg1yqyn2FgYLwW48qqXIIyzO2Oe20-7EY

            // Create the script tag, set the appropriate attributes
            var script = document.createElement('script');
            const apiKey = 'AIzaSyB4aUhPOo1iKsajP_naW2Y7KKmPT9gz2PI';
            script.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&callback=initMap';
            script.async = true;

            // Attach your callback function to the `window` object
            window.initMap = function() {
                // JS API is loaded and available


                let map;

                function initMap() {
                    const styledMapType = new google.maps.StyledMapType(
                        [
                            {
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#DFDFDF"
                                    }
                                ]
                            },
                            {
                                "elementType": "labels.icon",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#565656"
                                    }
                                ]
                            },
                            {
                                "elementType": "labels.text.stroke",
                                "stylers": [
                                    {
                                        "color": "#E2E2E2"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative.land_parcel",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#bdbdbd"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#eeeeee"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#757575"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#e5e5e5"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#9e9e9e"
                                    }
                                ]
                            },
                            {
                                "featureType": "road",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#ffffff"
                                    }
                                ]
                            },
                            {
                                "featureType": "road",
                                "elementType": "labels.icon",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.arterial",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#757575"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#dadada"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#616161"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.local",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#9e9e9e"
                                    }
                                ]
                            },
                            {
                                "featureType": "transit",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "transit.line",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#e5e5e5"
                                    }
                                ]
                            },
                            {
                                "featureType": "transit.station",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#eeeeee"
                                    }
                                ]
                            },
                            {
                                "featureType": "water",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#c9c9c9"
                                    }
                                ]
                            },
                            {
                                "featureType": "water",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#9e9e9e"
                                    }
                                ]
                            }
                        ],
                        { name: "Styled Map" }
                    );

                    const maps = $('.block-locations__map');
                    const arrayMap = [];
                    const arrayMarkers = [];

                    for (var a=0; a<maps.length; a++){
                        const lat = Number(maps.eq(a).data('lat'));
                        const long = Number(maps.eq(a).data('long'));

                        if (lat !== 0 && long !==0){
                            arrayMap[a] = new google.maps.Map(document.getElementsByClassName("block-locations__map")[a], {
                                center: { lat: Number(maps.eq(a).data('lat')), lng: Number(maps.eq(a).data('long')) },
                                zoom: 14,
                                disableDefaultUI: true,
                                mapTypeControlOptions: {
                                    mapTypeIds: ["styled_map"],
                                },
                            });


                            new google.maps.Marker({
                                position: { lat: Number(maps.eq(a).data('lat')), lng: Number(maps.eq(a).data('long')) },
                                map: arrayMap[a],
                                title: "",
                            });

                            //Associate the styled map with the MapTypeId and set it to display.
                            arrayMap[a].mapTypes.set("styled_map", styledMapType);
                            arrayMap[a].setMapTypeId("styled_map");

                            arrayMarkers[a] = new google.maps.Marker({
                                map:arrayMap[a],
                                // draggable:true,
                                // animation: google.maps.Animation.DROP,
                                position: new google.maps.LatLng(Number(maps.eq(a).data('lat')), Number(maps.eq(a).data('long'))),
                                icon: domainTemplate + '/img/google-maps-marker.png' // null = default icon
                            });
                        }
                    }

                }

                initMap();
            };

            // Append the 'script' element to 'head'
            document.head.appendChild(script);


    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=locations', initializeBlock);
    }
});
